/* home banner */
import banner1 from '../public/images/主页banner1-m.jpg';
import banner2 from '../public/images/主页banner2-m.jpg';
/* client logo */
import unice from '../public/images/unice@2x.png';
import uwwo from '../public/images/uwwo@2x.png';
import aowei from '../public/images/aowei@2x.png';
import tidebuy from '../public/images/tidebuy@2x.png';
import zeelool from '../public/images/zeelool@2x.png';
import isee from '../public/images/isee@2x.png';
import orderplus from '../public/images/orderplus@2x.png';
import alibaba from '../public/images/alibaba@2x.png';
import tencent from '../public/images/tencent@2x.png';
import tomtop from '../public/images/tomtop@2x.png';
import ecotric from '../public/images/ecotric@2x.png';
import alipearl from '../public/images/alipearl@2x.png';

export const homeBanners = [
  { image: banner1, link: '/contactus', alt: 'hidream讯梦国际' },
  { image: banner2, link: '/', alt: 'hidream-google' },
];

export const clientLogos = [
  {
    img: unice,
    alt: 'unice',
  },
  {
    img: uwwo,
    alt: 'uwwo',
  },
  {
    img: aowei,
    alt: 'aowei',
  },
  {
    img: tidebuy,
    alt: 'tidebuy',
  },
  {
    img: zeelool,
    alt: 'zeelool',
  },
  {
    img: isee,
    alt: 'isee',
  },
  {
    img: orderplus,
    alt: 'orderplus',
  },
  {
    img: alibaba,
    alt: 'alibaba',
  },
  {
    img: tencent,
    alt: 'tencent',
  },
  {
    img: tomtop,
    alt: 'tomtop',
  },
  {
    img: ecotric,
    alt: 'ecotric',
  },
  {
    img: alipearl,
    alt: 'alipearl',
  },
];

const homeData = { homeBanners, clientLogos };
export default homeData;
